import { render, staticRenderFns } from "./ShareHolderAndManagementInfo.vue?vue&type=template&id=d1839556&scoped=true&"
import script from "./ShareHolderAndManagementInfo.vue?vue&type=script&lang=js&"
export * from "./ShareHolderAndManagementInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShareHolderAndManagementInfo.vue?vue&type=style&index=0&id=d1839556&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1839556",
  null
  
)

export default component.exports